import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import erpBanner from "../images/school-1.png";
import erpBig from "../images/school-2.png";
import erpCollage from "../images/school-3.png";

import {
  FaSchool,
  FaUserGraduate,
  FaMoneyCheckAlt,
  FaClipboardList,
  FaChartLine,
  FaUserShield
} from "react-icons/fa";

function SchoolERP() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sidebar = [
    { title: "Customized School ERP Solution", icon: FaSchool },
    { title: "Student & Staff Management", icon: FaUserGraduate },
    { title: "Fees, Payroll & Finance", icon: FaMoneyCheckAlt },
    { title: "Attendance, Exams & Reports", icon: FaClipboardList },
    { title: "Analytics & Performance Tracking", icon: FaChartLine },
    { title: "Secure Data & Role-Based Access", icon: FaUserShield },
  ];

  const features = [
    "Admissions & student lifecycle management",
    "Attendance, exams & timetable",
    "Fees, payroll & accounting",
    "Parent-teacher communication",
    "Cloud-based secure access",
  ];

  return (
    <ServiceTemplate
      title="CUSTOMIZED SCHOOL ERP"
      bannerImage={erpBanner}
      bigImage={erpBig}
      collageImage={erpCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}

export default SchoolERP;
